import React, {useContext, useState} from "react";
import {Toaster, toast} from "react-hot-toast";
import SchoolContext from "../../../Context/SchoolContext";
import ajaxSchool from "../../../util/remote/ajaxSchool";

function AddTerm() {
  const {getTermsList} = useContext(SchoolContext);
  const [termName, setTermName] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [loading, setLoading] = useState(false);


  const handleAdd = async (e) => {
    e.preventDefault();

    if (termName.length > 0 || startDate.length > 0 || endDate.length > 0) {
      const data = {
        term_name: termName,
        start_date: startDate,
        end_date: endDate
      };
      setLoading(true)
      const server_response = await ajaxSchool.createSchoolTerm(data);
      setLoading(false)
      if (server_response.status === "OK") {
        toast.success(server_response.message);
        getTermsList();
        resetForm();
      } else {
        toast.error(server_response.message);
      }
    } else {
      toast.error("Complete all fields and try again");
    }
  };

  const resetForm = () => {
    setTermName("");
    setStartDate("");
    setEndDate("");
  };

  return (
    <>
      <Toaster position="top-center" reverseOrder={false} />

      <div className="row">
        
        <div className="col-lg-12 col-md-12">
          <div className="card custom-card" style={{borderRadius: "10px"}}>
            <div className="card-body">
              <div>
                <h5 className="card-title">Add New Term</h5>
              </div>

              <form
                onSubmit={(e) => handleAdd(e)}
                method="post"
                class="new-added-form">
                <div className="row">
                  <div className="col-xl-12 col-lg-12 col-md-12 form-group mt-2 radius-30">
                    <label htmlFor="">Term Name <span style={{color:"red"}}>*</span></label>
                    <input
                      type="text"
                      value={termName}
                      placeholder="Enter name of term..."
                      style={{border: "1px solid grey"}}
                      onChange={(e) => setTermName(e.target.value)}
                      className=" colo-12 form-control"
                    />
                  </div>
                  <div className="col-xl-12 col-lg-12 col-md-12 form-group mt-2 radius-30">
                    <label htmlFor="">Start Date <span style={{color:"red"}}>*</span></label>
                    <input
                      type="date"
                      value={startDate}
                      placeholder="Enter start date of term..."
                      style={{border: "1px solid grey"}}
                      onChange={(e) => setStartDate(e.target.value)}
                      className=" colo-12 form-control"
                    />
                  </div>
                  <div className="col-xl-12 col-lg-12 col-md-12 form-group mt-2 radius-30">
                    <label htmlFor="">End Date <span style={{color:"red"}}>*</span></label>
                    <input
                      type="date"
                      value={endDate}
                      placeholder="Enter end date of term..."
                      style={{border: "1px solid grey"}}
                      onChange={(e) => setEndDate(e.target.value)}
                      className=" colo-12 form-control"
                    />
                  </div>
                </div>
                <div className="mt-5">
                {loading && (<button type="submit" className="col-xl-12 col-lg-12 col-12 btn-fill-lmd radius-30 text-light shadow-dodger-blue bg-dodger-blue" disabled><i class="fa fa-spinner fa-spin mr-2"></i>Saving...</button>)}
                  {!loading && <button
                    type="submit"
                    className="col-xl-12 col-lg-12 col-12 btn-fill-lmd radius-30 text-light shadow-dodger-blue bg-dodger-blue">
                    Save Term
                  </button>}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddTerm;
